import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DeliverablesService {

  constructor(private http: HttpClient) { }
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // TODO: better job of transforming error for user consumption
      // this.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getDeliverableInformation(agreementId: any, agreementYear: string ) {
    let param = new HttpParams();
    let url = '';
    if (agreementYear !== null) {
      param = param.append('agreementYear', agreementYear);
    }
    url = environment.serviceURL + environment.getDeliverableInformation + agreementId;
    return this.http.get<any>(url, { params: param });
  }

  postDeliverableInformation(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.postDeliverableInformation, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  deleteDeliverableInformation(delDeliverableIds: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json'
      }),
      body: delDeliverableIds
    };
    return this.http.delete<any>(environment.serviceURL + environment.deleteDeliverableInformation, httpOptions).pipe(
      tap(), catchError(this.handleError<any>('delete deliverable')));
  }

  getDeliverablePeriod() {
    return this.http.get<any>(environment.serviceURL + environment.getDeliverablePeriod);
  }

  getDeliverablePeriodValue(deliverablePeriodId: any) {
    return this.http.get<any>(environment.serviceURL + environment.getDeliverablePeriodValue + deliverablePeriodId);
  }

  getDeliverablesDetail(deliverableId: any ) {
    let param = new HttpParams();
    let url = '';
    url = environment.serviceURL + environment.getDeliverableDetails + deliverableId;
    return this.http.get<any>(url, { params: param });
  }

  postDeliverableDetails(saveRequestBody: any) {
    return this.http.post(environment.serviceURL + environment.postDeliverableDetails, saveRequestBody, { headers: { 'Content-Type': 'application/json; charset=utf-8' } });
  }

  deleteDeliverableDetails(delDeliverableIds: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json-patch+json'
      }),
      body: delDeliverableIds
    };
    return this.http.delete<any>(environment.serviceURL + environment.deleteDeliverableDetails, httpOptions).pipe(
      tap(), catchError(this.handleError<any>('delete deliverable')));
  }

}
